import { useState } from "react";
import { toast } from "sonner";
import { ClipboardPaste, FileSpreadsheet, ShoppingCart, AlertTriangle } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { GlassCard, GradButton } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

const Sonuc = ({ s, onEkle }) => (
  <GlassCard className="p-4 space-y-3" data-testid="hizli-sonuc">
    {s.bulunan.length > 0 && (
      <div className="space-y-1.5">
        <div className="text-sm font-medium">{s.bulunan.length} ürün bulundu</div>
        <div className="max-h-72 overflow-y-auto erp-scroll space-y-1">
          {s.bulunan.map((u) => (
            <div key={u.id} className="grid grid-cols-12 gap-2 text-sm" data-testid={`hizli-bulunan-${u.kod}`}>
              <span className="col-span-3 font-mono text-xs text-muted-foreground truncate">{u.kod}</span>
              <span className="col-span-7 truncate">{u.ad}</span><span className="col-span-2 text-right font-mono">{u.miktar}</span>
            </div>
          ))}
        </div>
        <GradButton data-testid="hizli-sepete-ekle" onClick={onEkle}><ShoppingCart className="w-4 h-4" />Hepsini sepete ekle</GradButton>
      </div>
    )}
    {s.bulunamayan.length > 0 && (
      <div className="text-xs text-amber-300 space-y-1" data-testid="hizli-bulunamayan">
        <div className="flex items-center gap-1.5"><AlertTriangle className="w-3.5 h-3.5" />{s.bulunamayan.length} satır eklenemedi:</div>
        <div className="font-mono">{s.bulunamayan.map((b) => `${b.kod} (satır ${b.satir}${b.sebep && b.sebep !== "Kod bulunamadı" ? `: ${b.sebep}` : ""})`).join(", ")}</div>
      </div>
    )}
  </GlassCard>
);

export const BayiHizli = ({ onEkle }) => {
  const [metin, setMetin] = useState("");
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const cozumle = async (dosya) => {
    const fd = new FormData();
    if (dosya) fd.append("dosya", dosya); else fd.append("metin", metin);
    setBusy(true);
    try { setS((await api.post("/bayi/hizli-cozumle", fd, { headers: { "Content-Type": "multipart/form-data" } })).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const ekle = () => { onEkle(s.bulunan); toast.success(`${s.bulunan.length} ürün sepete eklendi`); setS(s.bulunamayan.length ? { ...s, bulunan: [] } : null); setMetin(""); };
  return (
    <div className="space-y-4" data-testid="bayi-hizli">
      <p className="text-sm text-muted-foreground">Her satıra bir stok kodu ve miktar yazın (ör. <span className="font-mono">1H0145834E-1930 10</span>) ya da Excel/CSV yükleyin: 1. sütun stok kodu, 2. sütun miktar. Miktar yoksa 1 alınır.</p>
      <Textarea data-testid="hizli-metin" rows={8} value={metin} onChange={(e) => setMetin(e.target.value)} placeholder={"1H0145834E-1930 10\n3C0145828K;5"} className="bg-white/5 font-mono text-sm" />
      <div className="flex flex-wrap gap-3">
        <GradButton data-testid="hizli-cozumle" disabled={busy || !metin.trim()} onClick={() => cozumle()}><ClipboardPaste className="w-4 h-4" />{busy ? "Kontrol ediliyor…" : "Kodları kontrol et"}</GradButton>
        <label className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm bg-white/10 hover:bg-white/15 cursor-pointer" data-testid="hizli-dosya-label">
          <FileSpreadsheet className="w-4 h-4" />Excel / CSV yükle
          <input type="file" accept=".xlsx,.xls,.csv,.txt" className="hidden" data-testid="hizli-dosya" onChange={(e) => { const f = e.target.files?.[0]; if (f) cozumle(f); e.target.value = ""; }} />
        </label>
      </div>
      {s && <Sonuc s={s} onEkle={ekle} />}
    </div>
  );
};
